import React from 'react';
import ChartWidget from '../../common/chart-widgets/ChartWidget';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import NoCoverageWidget from '../../common/chart-widgets/NoCoverageWidget';
import NoPlanWidget from '../../common/chart-widgets/NoPlanWidget';
import { getAccumulatorDataSet, getPermissions } from './helper';
import { useTranslation } from 'react-i18next';
import { insertSpaces } from '../../../utils/strings';
import { useSelector } from 'react-redux';
const CoverageCards = ({
  accumulateSummary,
  activeMember,
  activeMemberIndex,
  defaultNetworkForAll,
  skeletonLoader,
}) => {
  const accumulatorData = getAccumulatorDataSet(
    accumulateSummary,
    activeMember,
  );
  const viewPermission = getPermissions();
  const cardFocus = () => {
    document
      .querySelectorAll('li.react-multi-carousel-item')
      .forEach((d) => removeAriaHidden(d));
  };
  const removeAriaHidden = (d) => {
    d.setAttribute('aria-hidden', false);
  };
  const defaultNetwork =
    defaultNetworkForAll &&
    defaultNetworkForAll.find(
      (netwrok) => netwrok?.planProduct === accumulateSummary.Product,
    );
  const {
    Display_Network_For_Coverage_Member,
    Value_Network_For_Coverage_Member,
  } = useSelector((state) => state.app.appConfigs.Network_Setting);
  const { networkListWithMasterId } = useSelector(
    ({ memberSummary }) => memberSummary,
  );
  console.log(defaultNetwork?.defaultNetwork, 'defaultNetwork');
  const { t } = useTranslation();

  const getCorrespondingNetwork = () => {
    if (
      networkListWithMasterId?.length > 0 &&
      Display_Network_For_Coverage_Member &&
      Value_Network_For_Coverage_Member === 'tier'
    ) {
      const networkRecord = networkListWithMasterId.filter(
        (network) => network.masterId == accumulateSummary.MasterId,
      );
      if (networkRecord?.length > 0) {
        console.log(networkRecord[0]);
        if (networkRecord[0].data?.length > 0) {
          let networkTierName = null;
          networkRecord[0].data.forEach((eachItem) => {
            if (eachItem?.NetworkTier && networkTierName == null) {
              networkTierName = eachItem.NetworkTier;
            }
          });
          return networkTierName;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  return (
    <div className="carousel-li-item">
      <div className="item-wrapper">
        <Card
          aria-describedby={`${accumulateSummary.Product}productname`}
          aria-live="polite"
        >
          <div
            id={`${accumulateSummary.Product}productname`}
            className="sr-only"
          >{`Details of ${accumulateSummary.Product} Coverage`}</div>
          {viewPermission.verifyDedOOP && (
            <Card.Body>
              <div className="card-body-wrapper">
                {accumulatorData.BenefitPlan ? (
                  <div className="chart-container">
                    {Boolean(accumulatorData.dedPlanAmount) && (
                      <ChartWidget
                        label="deductables"
                        totalAmount={accumulatorData.dedPlanAmount}
                        spendingAmount={accumulatorData.dedSpentAmount}
                      />
                    )}

                    {Boolean(!accumulatorData.dedPlanAmount) &&
                      //This is temporary condition to hide NoPlanWidget for Disability product
                      accumulateSummary.Product !== 'ShortTermDisability' &&
                      accumulateSummary.Product !== 'LongTermDisability' && (
                        <NoPlanWidget label="deductables" />
                      )}

                    {Boolean(accumulatorData.outOfPocketPlanAmount) && (
                      <ChartWidget
                        label="out-of-pocket"
                        totalAmount={accumulatorData.outOfPocketPlanAmount}
                        spendingAmount={accumulatorData.outOfPocketSpentAmount}
                      />
                    )}
                    {Boolean(!accumulatorData.outOfPocketPlanAmount) &&
                      //This is temporary condition to hide NoPlanWidget for Disability product
                      accumulateSummary.Product !== 'ShortTermDisability' &&
                      accumulateSummary.Product !== 'LongTermDisability' && (
                        <NoPlanWidget label="out-of-pocket" />
                      )}
                  </div>
                ) : (
                  <div className="chart-container">
                    <NoCoverageWidget link={''} />
                  </div>
                )}
              </div>
            </Card.Body>
          )}
          <Card.Footer
            className={
              !viewPermission.verifyDedOOP
                ? 'text-muted border-top-0'
                : 'text-muted'
            }
          >
            <div className="card-footer-content">
              <h3>{insertSpaces(accumulateSummary.Product)}</h3>
              <p
                className={
                  accumulatorData.BenefitPlan
                    ? 'mb-1 plan-name'
                    : 'mb-1 plan-name invisible'
                }
              >
                {t('member.dashboard.coverage.plan')}{' '}
                <span>
                  {' '}
                  {accumulateSummary.BenefitPlan &&
                    accumulateSummary.BenefitPlan}
                </span>
              </p>
              {getCorrespondingNetwork() != null ? (
                <>
                  {
                    <p className="mb-1 plan-name">
                      Network/Tier:&nbsp;
                      <span>{getCorrespondingNetwork()}</span>{' '}
                    </p>
                  }
                </>
              ) : (
                <>
                  {defaultNetwork?.defaultNetwork !== undefined &&
                    Value_Network_For_Coverage_Member === 'network' && (
                      <p className="mb-1 plan-name">
                        Network/Tier:&nbsp;
                        <span>{defaultNetwork?.defaultNetwork}</span>{' '}
                      </p>
                    )}
                </>
              )}
              {/*{defaultNetwork?.defaultNetwork!==undefined&&<p className="plan-name">Network/Tier:&nbsp;<span>{defaultNetwork?.defaultNetwork}</span> </p>} */}
              {viewPermission.verifyCoverageDetails &&
                (accumulateSummary.Product === 'Medical'
                  ? viewPermission.verifyMedicalCoverage
                  : true) &&
                (accumulateSummary.Product === 'Prescription'
                  ? viewPermission.verifyPrescriptionCoverage
                  : true) &&
                (accumulateSummary.Product === 'Dental'
                  ? viewPermission.verifyDentalCoverage
                  : true) &&
                (accumulateSummary.Product === 'Vision'
                  ? viewPermission.verifVisionCoverage
                  : true) &&
                (accumulateSummary.Product === 'LongTermDisability'
                  ? viewPermission.verifyLongTermDisabilityCoverage
                  : true) &&
                (accumulateSummary.Product === 'ShortTermDisability'
                  ? viewPermission.verifyShortTermDisabilityCoverage
                  : true) &&
                (accumulateSummary.Product === 'Supplemental'
                  ? viewPermission.verifySupplementalCoverage
                  : true) && (
                  <p
                    className={
                      accumulatorData.BenefitPlan
                        ? 'mt-3 coverage-link'
                        : 'mt-3 coverage-link invisible'
                    }
                  >
                    <Link
                      to={`/member/coverage?selectedIndex=${activeMemberIndex}&coverageType=${accumulateSummary.Product}`}
                      onBlur={() => cardFocus()}
                    >
                      {t('member.dashboard.coverage.view')}{' '}
                      <span className="sr-only">
                        {accumulateSummary.Product}
                      </span>{' '}
                      {t('member.dashboard.coverage.coverage_details')}{' '}
                    </Link>
                  </p>
                )}
            </div>
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
};

export default CoverageCards;
